// export const { ipcRenderer } = window.require('electron')

const ipcRenderer = process.platform != "browser" ? require('electron').ipcRenderer : '';
//const ipcRenderer = require('electron').ipcRenderer;
import store from '../store'
import router from '../router'
import { com_url } from "../../config/endpoints";
import uniqid from "uniqid";
import { APPOINTMENT_NOTIFICATION, CHAT_NOTIFICATION, CLICK_NOTIFICATION, SHOW_NOTIFICATION } from './constants';

// invoke notification event to main process
export function showNotification(payload) {
  const { type, chatroom_id, data } = payload
  console.log('payloadpayload',payload)
  if (process.platform != "browser"&&router.history.current.path != '/appointments/chat-with-a-doctor/' + chatroom_id) {
    ipcRenderer.send( SHOW_NOTIFICATION, payload )
    
  }
}
// read notification click event from main process
process.platform != "browser" && ipcRenderer.on(CLICK_NOTIFICATION, (event, ...args) => {
  //ipcRenderer.on(CLICK_NOTIFICATION, (event, ...args) => {
  console.log('notification click : ', args);
  const [{ type, chatroom_id, data }] = args
  let notInCall = store.getters.getNavigate;
  switch (type) {
    case CHAT_NOTIFICATION:
      // redirect to chat screen;
      console.log('notification from : ', chatroom_id)
      // handle chat redirection
      if (router.history.current.path != '/appointments/chat-with-a-doctor/' + chatroom_id && notInCall) {
        router.push({ path: '/appointments/chat-with-a-doctor/' + chatroom_id })
      } else {
        console.log('already in same chat room');
      }
      break;
    case APPOINTMENT_NOTIFICATION:
      if(notInCall) {
        router.push({ path: '/appointments/doctor-details/' + data.id })
      } else {
        console.log('user in video call');
      }
      break;
    default:
      break;
  }  
})